import { render, staticRenderFns } from "./gasDetailDialogWin.vue?vue&type=template&id=51a7aa67&"
import script from "./gasDetailDialogWin.vue?vue&type=script&lang=js&"
export * from "./gasDetailDialogWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports